module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-23.7f9d5d1f.png";